import { all, fork, call, put, select, takeLatest } from 'redux-saga/effects';
import api from '@api/api';
import * as actions from '@store/actions/mobileOmniListAction';

import { SHOW_MODAL } from '@store/actions/commonAction';
import { isFunction } from '@common/utils';

// 모바일 옴니 현황 목록 조회
function* searchMobileOmniList() {
  const { searchParams } = yield select(state => state.mobileOmniListReducer);
  const { status, data } = yield call(api.searchMobileOmniList, {
    params: {
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      compCd: searchParams.compCd,
    },
    payload: {
      searchName: searchParams.customerName,
      pageConditionKey: '',
      pageCount: 10,
      pageNextYn: '',
    },
  });
  console.log('### status / data => ', status, data);
  if (status === 200) {
    yield put({
      type: actions.SEARCH_MOBILE_OMNI_LIST_SUCCESS,
      payload: {
        list: data.pagingResult.list,
        pageConditionKey: data.pagingResult.pageConditionKey,
        pageCount: data.pagingResult.pageCount,
        pageNextYn: data.pagingResult.pageNextYn,
      },
    });
  }
}

function* infiniteSearchMobileOmniList() {
  const { searchParams } = yield select(state => state.mobileOmniListReducer);

  if (searchParams.pageNextYn === 'N') return;

  const { status, data } = yield call(api.searchMobileOmniList, {
    params: {
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      compCd: searchParams.compCd,
    },
    payload: {
      searchName: searchParams.customerName,
      pageConditionKey: searchParams.pageConditionKey,
      pageCount: 10,
      pageNextYn: searchParams.pageNextYn,
    },
  });
  console.log('### status / data => ', status, data);

  if (status === 200) {
    yield put({
      type: actions.INFINITE_SEARCH_MOBILE_OMNI_LIST_SUCCESS,
      payload: {
        list: data.pagingResult.list,
        pageConditionKey: data.pagingResult.pageConditionKey,
        pageCount: data.pagingResult.pageCount,
        pageNextYn: data.pagingResult.pageNextYn,
      },
    });
  }
}

// 옴니 모바일 전송
function* sendSmsOmni({ payload }) {
  const { status, data } = yield call(api.sendSmsOmni, {
    payload: {
      publishNumber: payload.applicationNo,
      docType: payload.docType ? payload.docType : '1',
    },
  });
  if (status === 200) {
    if (isFunction(payload.callback)) payload.callback(true);
    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: `${
          payload.docType === '1' ? '고객님' : '설계사님'
        }의 휴대전화번호(${
          payload.customerCpNumber
        })으로\r\n모바일 옴니청약이 재발송되었습니다.`,
      },
    });
  } else {
    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: data.detail || '전송 실패 하였습니다.',
      },
    });
  }
}

// watcher
function* watchMobileOmniList() {
  yield takeLatest(actions.SAVE_SEARCH_PARAMS, searchMobileOmniList);
  yield takeLatest(actions.SEARCH_MOBILE_OMNI_LIST, searchMobileOmniList);
  yield takeLatest(
    actions.INFINITE_SEARCH_MOBILE_OMNI_LIST,
    infiniteSearchMobileOmniList,
  );
  yield takeLatest(actions.SEND_SMS_OMNI, sendSmsOmni);
}

export default function* mobileOmniListSaga() {
  yield all([fork(watchMobileOmniList)]);
}
